import { Controller, useFormContext } from "react-hook-form";
import { StyledTextField, StyledLabel } from "./StyleInputs";
import { Box } from "@mui/material";

const DatePickerField = ({ field }) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const errorMessage = errors[field.id]?.message;

  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel required={field.required}>{field.label}</StyledLabel>
      <Controller
        name={field.id}
        control={control}
        defaultValue={null}
        rules={{
          required: field.required ? `${field.label} is required` : false,
        }}
        render={({ field: { onChange, value, ref } }) => (
          <StyledTextField
            type="date"
            fullWidth
            placeholder={field.placeholder}
            value={value}
            onChange={onChange}
            inputRef={ref}
            error={!!errorMessage}
            helperText={errorMessage}
            variant="outlined"
            slotProps={{
              inputLabel: {
                shrink: true,
              },
              input: {
                notched: false,
              },
            }}
            label=""
          />
        )}
      />
    </Box>
  );
};

export default DatePickerField;
